import { createStyles } from '@mantine/core';

export const useStyles = createStyles((theme) => ({
  modal: {
    width: '720px',
    maxWidth: 860,
  },
  modalBody: {
    padding: theme.other.spacing._24,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.other.spacing._16,
  },
  modalHeader: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: theme.other.spacing._2,
  },
  listFrame: {
    border: `1px solid ${theme.colors.gray[0]}`,
    borderRadius: theme.radius.lg,
    overflow: 'hidden',
    backgroundColor: theme.white,
  },
  itemsHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: `${theme.other.spacing._8}px ${theme.other.spacing._16}px`,
    borderBottom: `1px solid ${theme.colors.gray[0]}`,
    backgroundColor: theme.colors.gray[0],
  },
  itemsList: {
    maxHeight: 520,
    overflow: 'auto',
  },
  itemsListLoadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.other.spacing._8,
    padding: theme.other.spacing._16,
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: `${theme.other.spacing._8}px ${theme.other.spacing._16}px`,
    borderBottom: `1px solid ${theme.colors.gray[0]}`,

    '&:last-of-type': {
      borderBottom: 'none',
    },
  },
  playerColumn: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.other.spacing._8,
    minWidth: 0,
  },
  playerImage: {
    objectFit: 'contain',
  },
  emptyState: {
    borderRadius: theme.radius.lg,
    backgroundColor: theme.colors.gray[0],
    padding: theme.other.spacing._32,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: theme.other.spacing._8,
  },
}));
